import { render, staticRenderFns } from "./DxpServiceProviderConfigurationUpdate.vue?vue&type=template&id=b3672dc8"
import script from "./DxpServiceProviderConfigurationUpdate.vue?vue&type=script&lang=js"
export * from "./DxpServiceProviderConfigurationUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports